import { Flex, Box } from "@otrium/core";
import styled from "@emotion/styled";
import { scrollbar } from "src/scrollbar";

export const Wrapper = styled.div<{ withMobileOverlay: boolean }>`
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -4px 8px 0 ${({ theme }) => theme.effects.overlay.black_10};
  border-radius: 16px 16px 0 0;
  background-color: ${({ theme }) => theme.colors.tone.white};
  max-height: 70dvh;
  display: flex;
  flex-direction: column;
  left: ${({ withMobileOverlay }) => (withMobileOverlay ? "unset" : 0)};
  visibility: visible;
  pointer-events: auto;
  overflow: hidden;
  z-index: ${({ theme }) => theme.zIndex.drawer};
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 0;
`;

export const SizeListContainer = styled(Box)<{ hasSizeFitLabel?: boolean }>`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-left: 16px;
  padding-right: 16px;
  margin-right: 4px;
  margin-bottom: ${({ hasSizeFitLabel }) =>
    hasSizeFitLabel ? "135px" : "95px"};
  ${scrollbar}
`;

export const DrawerFooter = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.tone.white};
  box-shadow: 0 -4px 8px 0 ${({ theme }) => theme.effects.overlay.black_10};
  padding: 16px;
  z-index: 1;
`;

export const NotifyMeText = styled.span`
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.tone.black};
`;

export const SizeText = styled.span<{ $isOutOfStock?: boolean }>`
  text-decoration: ${({ $isOutOfStock }) =>
    $isOutOfStock ? "line-through" : "none"};
  color: ${({ theme, $isOutOfStock }) =>
    $isOutOfStock ? theme.colors.tone.silver : "inherit"};
`;

export const SizeRow = styled(Flex)<{
  selected: boolean;
  disabled?: boolean;
  $isOutOfStock?: boolean;
}>`
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: calc(100% + 32px);
  padding-left: 16px;
  padding-right: 16px;
  margin-left: -16px;
  margin-right: -16px;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    `
  background-color: ${theme.colors.tone.sand};
  font-weight: 600;
  `}
  ${({ disabled }) =>
    disabled &&
    `
  opacity: 0.4;
  cursor: not-allowed;
  `}

  &:hover {
    background-color: ${({ theme }) => theme.colors.tone.sand};

    ${({ $isOutOfStock }) =>
      $isOutOfStock
        ? `
      ${NotifyMeText} {
        text-decoration: underline;
      }
    `
        : `
      font-weight: 600;
    `}
  }
`;
